module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/icon-crm-lg-b4e6e224bd2e3162b5ce5ec1106e491c.png";